import * as React from 'react';
import DegreeOfferredPerMajors from '../DegreeOffering/degreeofferring2';
import ModuleContent from '../ModulePage/ModuleContent';
import APCP from '../APCP/apcp';
import MediaUploadPage from '../MediaUploadPage/MediaUploadPage';
import { WelcomeRouter } from '../Welcome';
import { MEDIA_UPLOAD } from '../../../constants/status';

const RightPanel = ({categoryName, org_id, cat_id, status,org_rol, cateTooltip, 
  categoryData,catDispatcher, setCategoryStatus, setPageDirty, selApiAttribute, setDisableBar, 
  setNavSelection, setSelApiAttribute, setCategoryName, dataCollectionTypes })=>{

  const [logoPingResult, setLogoPingResult] = React.useState(true);
  const [logoTimerId, setLogoTimerId] = React.useState();
  const [logoMediaMeta, setLogoMediaMeta] = React.useState({});

  const [bannerPingResult, setBannerPingResult] = React.useState(true);
  const [bannerTimerId, setBannerTimerId] = React.useState();
  const [bannerMediaMeta, setBannerMediaMeta] = React.useState({});

  React.useEffect(()=>{
    return() => {
      if(logoTimerId!==null&&!logoPingResult){
        clearInterval(logoTimerId);
        setLogoPingResult(true);
      }
      if(bannerTimerId!==null&&!bannerPingResult){
        clearInterval(bannerTimerId);
        setBannerPingResult(true);
      }
    };
  }, [logoPingResult, logoTimerId, setLogoPingResult, logoMediaMeta, setLogoMediaMeta,
    bannerPingResult, bannerTimerId, setBannerPingResult, bannerMediaMeta, setBannerMediaMeta,]);

  {/* Media upload related Start */}
  const startTimer = React.useCallback((current, newmeta) => {
    const intervalId = setInterval(()=>{
      setTimeout(()=>{
      pingDatabase(current, newmeta);},1000);
    }, 1000);
    if(current==='logo'){
      setLogoTimerId(intervalId);
    }
    if(current==='banner'){
      setBannerTimerId(intervalId);
    }
  }, [setLogoTimerId, pingDatabase]);

  const pingDatabase = React.useCallback((current, newmeta) =>{
    //call api
    if(Math.random()<0.08){
      const updatemeta = {...newmeta, status:'scanning'};
      if(current==='logo'){
        setLogoMediaMeta(updatemeta);
        setLogoPingResult(true);
      }
      if(current==='banner'){
        setBannerMediaMeta(updatemeta);
        setBannerPingResult(true);
      }
    }
    else{
      if(current==='logo'){
        setLogoPingResult(false);
        //const updatemeta = {...newmeta, status:'error_virus'};
        const updatemeta = {...newmeta, status:'success_upload'};
        setLogoMediaMeta(updatemeta);
      }

      if(current==='banner'){
        setBannerPingResult(false);
        //const updatemeta = {...newmeta, status:'error_virus'};
        const updatemeta = {...newmeta, status:'success_upload'};
        setBannerMediaMeta(updatemeta);
      }
    }
  }, [setLogoPingResult, setLogoMediaMeta, setBannerMediaMeta, setBannerPingResult]);

  const onUpload = (current, newmeta) => {
      startTimer(current, newmeta);
  };
  {/* Media upload related END*/}


  switch(selApiAttribute){
    case 'degreeOfferingsCategory':
    {
      return (
        <div style={{flex:'70%'}}>
        {<DegreeOfferredPerMajors CategoryName={categoryName} org_id={org_id} cat_id={cat_id} status={status} org_rol_s={org_rol} categTooltip={cateTooltip}  /> }
        </div>);
    }
    
    case 'apcpCreditPolicyCategory':
    {
      return (
        <div style={{flex:'70%'}}>
        {<APCP CategoryName={categoryName} org_id={org_id} cat_id={cat_id} status={status} 
        org_rol_s={org_rol} categTooltip={cateTooltip}
        categoryData={categoryData}
        catDispatcher={catDispatcher} 
        setPageDirty={setPageDirty}
        setCategoryStatus={setCategoryStatus}
        setDisableBar={setDisableBar}
        /> }
        </div>);
    }
    
    case "welcome": {
      return (<WelcomeRouter org_rol_s={org_rol} org_id={org_id} 
        setNavSelection={setNavSelection} setSelApiAttribute={setSelApiAttribute} 
        setCategoryName={setCategoryName} 
        dataCollectionTypes={dataCollectionTypes}/>);
    }

    case MEDIA_UPLOAD:{
      return (<MediaUploadPage 
              logoMediaMeta={logoMediaMeta} 
              setLogoMediaMeta={setLogoMediaMeta} 
              onUpload={onUpload} 
              org_role={org_rol} 
              org_id={org_id}
              bannerMediaMeta={bannerMediaMeta} 
              setBannerMediaMeta={setBannerMediaMeta}
              />)
    }

    default:
    {
      return (
      <div style={{flex:'70%'}}>
      {<ModuleContent CategoryName={categoryName} org_id={org_id} cat_id={cat_id} status={status} 
      org_rol_s={org_rol} categTooltip={cateTooltip}
      categoryData={categoryData}
      catDispatcher={catDispatcher}
      setCategoryStatus={setCategoryStatus}
      setDisableBar={setDisableBar}
      selApiAttribute={selApiAttribute}
      /> }
      </div>);
    }
  }
};

export default RightPanel;